import React from 'react';
import { Box } from '@qga/roo-ui/components';

import Skeleton from '../Base';
import InputSkeleton from '../Input';

const FormControlSkeleton = (props) => (
  <Box
    {...props} // eslint-disable-line react/jsx-props-no-spreading
  >
    <Skeleton width="5rem" />
    <Box mt="3px">
      <InputSkeleton />
    </Box>
  </Box>
);

export default FormControlSkeleton;
